import { render, staticRenderFns } from "./active2.vue?vue&type=template&id=6bc51100&scoped=true"
import script from "./active2.vue?vue&type=script&lang=js"
export * from "./active2.vue?vue&type=script&lang=js"
import style0 from "./active2.vue?vue&type=style&index=0&id=6bc51100&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc51100",
  null
  
)

export default component.exports